export const sendEmail = () => {
  const email = 'contact@paunmihai.com';
  const subject = 'Oferta website';
  const message = 'Cerintele dumneavoastra aici:';

  const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;

  window.location.href = mailtoLink;
};